var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 67.4 67.4",
    style: {
      enableBackground: "new 0 0 67.4 67.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#221E1B;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "git",
    transform: "translate(-2.555 -2.558)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.7,0.8C15.1,0.8,0,15.9,0,34.5c0,14.9,9.7,27.5,23,32c1.7,0.3,2.3-0.7,2.3-1.6c0-0.8,0-2.9,0-5.7 c-9.4,2-11.4-4.5-11.4-4.5c-1.5-3.9-3.7-4.9-3.7-4.9c-3.1-2.1,0.2-2,0.2-2c3.4,0.2,5.2,3.5,5.2,3.5c3,5.1,7.9,3.7,9.8,2.8 c0.3-2.2,1.2-3.7,2.1-4.5c-7.5-0.9-15.4-3.7-15.4-16.7c0-3.7,1.3-6.7,3.5-9c-0.3-0.9-1.5-4.3,0.3-8.9c0,0,2.8-0.9,9.3,3.5 c2.7-0.7,5.6-1.1,8.4-1.1c2.9,0,5.7,0.4,8.4,1.1c6.4-4.4,9.3-3.5,9.3-3.5c1.8,4.6,0.7,8.1,0.3,8.9c2.2,2.4,3.5,5.4,3.5,9 c0,12.9-7.9,15.8-15.4,16.6c1.2,1,2.3,3.1,2.3,6.2c0,4.5,0,8.1,0,9.2c0,0.9,0.6,1.9,2.3,1.6c13.4-4.5,23-17.1,23-32 C67.4,15.9,52.3,0.8,33.7,0.8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.a2343691fea0071f28f904a7d84919ab.svg";
export { ForwardRef as ReactComponent };